var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "90px",
    height: "90px",
    viewBox: "0 0 90 90",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Start",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-381.000000, -107.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(80.000000, 107.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M346,-1.13686838e-13 C358.426407,-1.13686838e-13 368.5,9.54340402 368.5,21.3157895 C368.5,24.2835885 367.859787,27.1097279 366.703062,29.6770175 C367.295531,29.6291433 367.894977,29.6052632 368.5,29.6052632 C380.926407,29.6052632 391,39.6788563 391,52.1052632 C391,64.53167 380.926407,74.6052632 368.5,74.6052632 C359.158018,74.6052632 351.145801,68.9118687 347.743857,60.8055904 L347.743935,60.5358244 C347.743935,68.3753084 348.346834,78.1967002 349.552632,90 L342.447368,90 C343.557233,76.6996253 344.127325,67.044171 344.157645,61.0336369 C340.702483,69.019083 332.753602,74.6052632 323.5,74.6052632 C311.073593,74.6052632 301,64.53167 301,52.1052632 C301,39.6788563 311.073593,29.6052632 323.5,29.6052632 C324.105023,29.6052632 324.704469,29.6291433 325.297447,29.6760126 C324.140213,27.1097279 323.5,24.2835885 323.5,21.3157895 C323.5,9.54340402 333.573593,-1.13686838e-13 346,-1.13686838e-13 Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClover);
export default __webpack_public_path__ + "static/media/Clover.0d1c3cf4.svg";
export { ForwardRef as ReactComponent };